module.exports = __webpack_public_path__ + "static/media/William Howard Taft - 1908.eb5dbe1e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/us/William Howard Taft - 1908.jpg
// module id = 568
// module chunks = 0